import { isDefined } from 'class-validator';

import { errorLocals } from 'src/locals';

import { statusHelper } from '.';
import { compatibleTypes } from '../components/FileTable/fileTable.config';

export type AttachmentType = {
  url: string;
  file: File;
};

export type UploadInputObject = { newImages: any; currentReplacedIndexes: any };

export const handleFileChosen = async (file: any): Promise<AttachmentType> => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();

    fr.onload = (fileReaderEvent: ProgressEvent<FileReader>) => {
      if (!fileReaderEvent.target?.result) {
        return;
      }
      resolve({ url: fileReaderEvent.target.result.toString(), file });
    };
    fr.onerror = reject;
    fr.readAsDataURL(file);
  });
};

export const handleOnChangeUploadInput = async (
  onChangeInputEvent: React.ChangeEvent<HTMLInputElement>,
  index: number | undefined,
  attachments: any,
  language: any,
  t: (key: string) => string,
): Promise<UploadInputObject | undefined> => {
  // represents the clicked image index
  let internalIndex = index;

  let imagesArray;
  if (!isDefined(index)) {
    imagesArray = attachments?.filter((i: any) => !!i);
    internalIndex = imagesArray?.length;
  }
  try {
    if (!onChangeInputEvent.target.files) {
      onChangeInputEvent.target.value = '';
      statusHelper.displayErrorMessage(t('errors.unknownError'));
      return;
    }

    if (onChangeInputEvent.target.files[0].size > 40000000) {
      onChangeInputEvent.target.value = '';
      statusHelper.displayErrorMessage(t('errors.max4Mb'));
      return;
    }
    if (!compatibleTypes.includes(onChangeInputEvent.target.files[0].type)) {
      onChangeInputEvent.target.value = '';
      statusHelper.displayErrorMessage(t('errors.fileNotCompatible'));
      return;
    }

    // get attachmensts' truthy form
    const newImages: any = attachments?.filter((i: any) => !!i);

    const currentReplacedIndexes: any = [];

    // iterate the selected images
    for (let i = 0; i < onChangeInputEvent.target.files.length; i += 1) {
      const image = onChangeInputEvent.target.files[i];

      if (!image) {
        onChangeInputEvent.target.value = '';
        statusHelper.displayErrorMessage(t('errors.unknownError'));
        return;
      }

      if (internalIndex !== undefined) {
        // will push ImageType when resolved, await takes care..
        newImages[internalIndex + i] = await handleFileChosen(image);

        // clicked image index plus current uploaded image index
        currentReplacedIndexes.push(internalIndex + i);
      }
    }

    const uploadInputObject: UploadInputObject = {
      newImages: newImages,
      // clicked image index plus current uploaded image index
      currentReplacedIndexes: currentReplacedIndexes,
    };

    return uploadInputObject;
    // await Promise.all(newImages);
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      onChangeInputEvent.target.value = '';
      statusHelper.displayErrorMessage(t('errors.unknownError'));
      return;
    }
  }
};
